import React, {ReactElement} from 'react';
import {IElementLine} from '../../../incase-domain/elements/shapes/line';

interface ElementRectangleComponentProps {
    element: IElementLine;
}

function ElementLineComponent(props: ElementRectangleComponentProps): ReactElement {
    const {element} = props;
    const {color, size} = element;

    return (
        <div className="c-line">
            <svg height="100%" width="100%">
                <line x1="0" y1="50%" x2="100%" y2="50%" stroke={color || 'black'} strokeWidth={`${size || '0.0625'}em`} />
            </svg>
        </div>
    );
}

export default ElementLineComponent;
